import { render, staticRenderFns } from "./TextCell.vue?vue&type=template&id=15e0db78&scoped=true"
import script from "./TextCell.vue?vue&type=script&lang=js"
export * from "./TextCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e0db78",
  null
  
)

export default component.exports